export default "__VITE_ASSET__h_DgttZ4__"